import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, mergeProps as _mergeProps, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-fbd2a92e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { style: {"display":"inline-block","margin-right":"10px"} }
const _hoisted_2 = { class: "list" }
const _hoisted_3 = ["title"]
const _hoisted_4 = ["title"]
const _hoisted_5 = {
  class: "name2",
  style: {"width":"160px"}
}
const _hoisted_6 = ["title"]
const _hoisted_7 = ["title"]
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { key: 1 }

import { ref } from 'vue'
import { DcMessage } from '@dc-platform/dc-components'
import { customerMerge as customerCustomerMerge } from '@/api/customer/index'
import { customerMerge as fbuCustomerMerge } from '@/api/gucangSales/customerCenter'
import { customerMerge as lbuCustomerMerge } from '@/api/yuntuSales/customerCenter'
import { customerMerge as ofbuCustomerMerge } from '@/api/overseasSales/customerCenter'
import type { PropType } from 'vue'
import { useI18n } from 'vue-i18n'
interface Customer {
  cosId?: string
}

export default /*#__PURE__*/_defineComponent({
  __name: 'cosMergeButton',
  props: {
  data: {
    type: Array as PropType<Customer[]>,
    default: () => {
      return []
    }
  },
  title: {
    type: String
  },
  tips: {
    type: String // 描述
  },
  fbuType: {
    type: Number, // 谷仓待合并客户所在阶段，2：潜在客户，3：签约客户，4：成交客户
    default: 2
  },
  appId: {
    type: String,
    default: 'cos_fbu'
  },
  fieldNames: {
    type: Object,
    default: () => {
      return { label: 'customerName', value: 'cosId' }
    }
  }
},
  emits: ['success'],
  setup(__props, { emit: __emit }) {

const { t } = useI18n()
const props = __props
const visible = ref<boolean>(false)
const loading = ref<boolean>(false)
const formRef = ref()
const editForm = ref<any>({})
const emit = __emit
const customerMergeMethod = {
  cos_fbu: fbuCustomerMerge,
  cos_lbu: lbuCustomerMerge,
  cos_ofbu: ofbuCustomerMerge
}
const handleSubmit = () => {
  formRef.value?.validate().then(async () => {
    loading.value = true
    const { masterCosId } = editForm.value
    const subCosIds: any[] = []
    props.data.forEach((item) => {
      if (item.cosId !== masterCosId) {
        subCosIds.push(item.cosId)
      }
    })
    const p = {
      masterCosId,
      subCosIds
    }
    if (props.appId === 'customer') {
      customerCustomerMerge(p)
        .then(() => {
          visible.value = false
          emit('success')
          DcMessage.success(t('tips.mergeSuccess'))
        })
        .finally(() => {
          loading.value = false
        })
    } else {
      const params: any = {
        targetCosId: p.masterCosId,
        originalIdList: p.subCosIds
      }
      if (props.appId === 'cos_fbu') {
        params.stage = props.fbuType
      }
      customerMergeMethod[props.appId](params)
        .then(() => {
          visible.value = false
          emit('success')
          DcMessage.success(t('tips.mergeSuccess'))
        })
        .finally(() => {
          loading.value = false
        })
    }
  })
}
const showModal = () => {
  // 验证数量
  if (!props.data || props.data.length < 2) {
    DcMessage.error(t('tips.mergeSelectData'))
    return
  }
  visible.value = true
  editForm.value = {}
}

return (_ctx: any,_cache: any) => {
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_alert = _resolveComponent("a-alert")!
  const _component_a_select_option = _resolveComponent("a-select-option")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_CosModal = _resolveComponent("CosModal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_a_button, _mergeProps({ onClick: showModal }, _ctx.$attrs), {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(_unref(t)('btn.merge')), 1)
      ]),
      _: 1
    }, 16),
    _createVNode(_component_CosModal, {
      visible: visible.value,
      "onUpdate:visible": _cache[1] || (_cache[1] = ($event: any) => ((visible).value = $event)),
      title: _unref(t)('custom.mergeCustormModalTitle'),
      width: __props.appId === 'customer' ? '1200px' : '780px',
      onOk: handleSubmit,
      confirmLoading: loading.value
    }, {
      default: _withCtx(() => [
        _createVNode(_component_a_alert, {
          message: _unref(t)('tips.mergeCustomModalTitle'),
          type: "warning",
          "show-icon": ""
        }, null, 8, ["message"]),
        _createElementVNode("ul", _hoisted_2, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.data, (item, index) => {
            return (_openBlock(), _createElementBlock("li", { key: index }, [
              _createElementVNode("p", null, _toDisplayString(_unref(t)('custom.AzbNzF')) + ":", 1),
              _createElementVNode("p", {
                class: "name flex1",
                title: item[__props.fieldNames.label]
              }, _toDisplayString(item[__props.fieldNames.label]), 9, _hoisted_3),
              (__props.appId === 'customer')
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createElementVNode("p", {
                      class: "name",
                      title: item.customerCode,
                      style: {"width":"300px"}
                    }, "客户代码：" + _toDisplayString(item.customerCode), 9, _hoisted_4),
                    _createElementVNode("p", _hoisted_5, "业务系统：" + _toDisplayString(item.$sys || item.sys || '--'), 1)
                  ], 64))
                : _createCommentVNode("", true),
              (__props.appId === 'cos_fbu' || __props.appId === 'cos_ofbu')
                ? (_openBlock(), _createElementBlock("p", {
                    key: 1,
                    class: "name",
                    style: {"width":"220px"},
                    title: item.cosId
                  }, " ID:" + _toDisplayString(item.cosId), 9, _hoisted_6))
                : (_openBlock(), _createElementBlock("p", {
                    key: 2,
                    class: "name",
                    style: {"width":"220px"},
                    title: item[__props.fieldNames.value]
                  }, " ID：" + _toDisplayString(item[__props.fieldNames.value]), 9, _hoisted_7))
            ]))
          }), 128))
        ]),
        (visible.value)
          ? (_openBlock(), _createBlock(_component_a_form, {
              key: 0,
              model: editForm.value,
              ref_key: "formRef",
              ref: formRef
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_form_item, {
                  name: "masterCosId",
                  label: _unref(t)('custom.EgVAzB'),
                  rules: [{ required: true, message: '请选择' }]
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_select, {
                      value: editForm.value.masterCosId,
                      "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((editForm.value.masterCosId) = $event)),
                      placeholder: _unref(t)('common.pleaseSelect')
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.data, (item) => {
                          return (_openBlock(), _createBlock(_component_a_select_option, {
                            key: item[__props.fieldNames.value]
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(item[__props.fieldNames.label]) + " ", 1),
                              (__props.appId === 'cos_fbu' || __props.appId === 'cos_ofbu')
                                ? (_openBlock(), _createElementBlock("span", _hoisted_8, "(" + _toDisplayString(item.cosId) + ")", 1))
                                : _createCommentVNode("", true),
                              (__props.appId === 'customer')
                                ? (_openBlock(), _createElementBlock("span", _hoisted_9, "(" + _toDisplayString(item.customerCode) + ")", 1))
                                : _createCommentVNode("", true)
                            ]),
                            _: 2
                          }, 1024))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["value", "placeholder"])
                  ]),
                  _: 1
                }, 8, ["label"])
              ]),
              _: 1
            }, 8, ["model"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["visible", "title", "width", "confirmLoading"])
  ]))
}
}

})